export const commonDrugBlockListErrors = [
    {
        drug: 'tretinoin',
        message: 'Not to be prescribed by GP - refer to Dermatologist (Health Legislation). Please empty the input and search another drug.',
        extras: {
            drugTakenRoute: 'oral'
        }
    }
];
